export enum PaymentFieldName {
  BANK_CODE = 'bankCode',
  CLEARING_NUMBER = 'clearingNumber',
  BANK_ACCOUNT_ID = 'bankAccountId',
  ACCOUNT_NUMBER = 'accountNumber',
  BENEFICIARY_NAME = 'beneficiaryName',
  BANK_ACCOUNT_LAST_NAME = 'bankAccountLastName',
  BANK_ACCOUNT_FIRST_NAME = 'bankAccountFirstName',
}
